export default function (multianalytics) {
  return {
    error(message) {
      if (typeof message === 'object' && message !== null) {
        multianalytics.trackEvent({
          category: 'Error',
          action: 'Error',
          label: 'Error',
          value: JSON.stringify(message),
        })
        // window.fbq('trackCustom', JSON.stringify(message))
      } else {
        multianalytics.trackEvent({
          category: 'Error',
          action: 'Error',
          label: 'Error',
          value: message,
        })
        // window.fbq('trackCustom', message)
      }
    },
    event(message) {
      // window.fbq('track', message)
      multianalytics.trackEvent({
        fb_event: message,
        category: message,
        action: message,
        label: message,
        value: JSON.stringify(message),
      })
    },
    deduplicateEvent(message, eventId) {
      // window.fbq('track', message)
      multianalytics.trackEvent({
        fb_event: message,
        category: message,
        action: message,
        label: message,
        value: JSON.stringify(message),
        ids: [eventId],
      })
    },
    eventWithValue(message, value) {
      // window.fbq('track', message)
      multianalytics.trackEvent({
        fb_event: message,
        category: message,
        action: message,
        label: message,
        value: value,
        currency: 'USD',
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/multianalytics.js